import React, { useContext } from 'react'
import { createPortal } from 'react-dom'
import { Button } from '@/components/ui/button'
import { VideoCameraIcon } from '@/components/icons/VideoCamera'
import { ProjectLayout } from '../dialog/projectLayout'
import { ProjectContext } from '@/context/ProjectContext'
import { customFetch } from '@/utils/fetch'
import toast from 'react-hot-toast'

interface JoinLiveMeetingDialogProps {
  handleClose: () => void
}

// TODO: Technically this should be moved out of the `/components/dashboard/home-new` path in the repo
//  since it's also used by project comps
export function JoinLiveMeetingDialog({ handleClose }: JoinLiveMeetingDialogProps): React.ReactElement {
  const [link, setLink] = React.useState('')
  const [showProjectDialog, setShowProjectDialog] = React.useState(false)
  const { project } = useContext(ProjectContext)
  const projectId = project?.id

  const handleSubmit = async () => {
    if (!link) return

    if (projectId) {
      try {
        await customFetch('/createBot', 'POST', { link, projectId })
        toast.success('Great! Go accept the bot into the meeting.')
        handleClose()
      } catch (error) {
        console.error('Error sending bot:', error)
      }
    } else {
      setShowProjectDialog(true)
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && link) {
      handleSubmit()
    }
  }

  const dialogContent = !showProjectDialog ? (
    <div className="fixed top-0 left-0 w-full h-full bg-black/30 z-50" onClick={handleClose}>
      <div
        className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[500px] bg-white rounded-lg p-6 shadow-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-xl font-semibold mb-4">Join Live Meeting</h2>
        <p className="text-gray-500 mb-4">
          To start transcribing and analyzing a live meeting, just paste the meeting link here:
        </p>
        <div className="relative mb-4">
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
            <VideoCameraIcon />
          </div>
          <input
            type="url"
            className="w-full h-10 pl-10 pr-4 text-sm text-gray-700 bg-gray-100 rounded border border-gray-200 focus:outline-none focus:border-[#FF4A8E]"
            placeholder="Paste meeting link"
            value={link}
            onChange={(e) => setLink(e.target.value)}
            onKeyDown={handleKeyDown}
            required
          />
        </div>
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={handleClose}>
            Cancel
          </Button>
          <Button className="bg-[#FF4A8E] hover:bg-[#E43D7A]" onClick={handleSubmit} disabled={!link}>
            Join Meeting
          </Button>
        </div>
      </div>
    </div>
  ) : (
    <ProjectLayout
      link={link}
      importFile={false}
      handleClose={() => {
        setShowProjectDialog(false)
        handleClose()
      }}
    />
  )

  return createPortal(dialogContent, document.body) as React.ReactElement
}
